$(() =>
  $('input[data-toggle-show-password="true"]').each((_i, element) => {
    const $checkbox = $(element);
    const $inputs = $($checkbox.data('toggle-show-password-selector'));

    const toggleShowPassword = () => {
      $inputs.attr('type', $checkbox.is(':checked') ? 'text' : 'password');
    };

    $checkbox.on('click', toggleShowPassword);
    toggleShowPassword();
  }),
);
